import {
  LOAD_INFO,
  LOAD_INFO_SUCCESS,
  LOAD_INFO_FAILURE,
  SET_AUTH_METHOD,
  WRONG_USER_MODE,
  InfoActionTypes,
} from "./info.types";
import {
  AuthInfo,
  AuthMethod,
  AuthServiceErrorCode,
  InfoData,
  isFailure,
} from "@sportal/api";
import { SBThunkAction } from "../redux.types";

export const loadInfo =
  (): SBThunkAction<void, InfoActionTypes> =>
  async (dispatch, getState, { api }) => {
    let authMethod;

    dispatch({ type: LOAD_INFO });

    const result = await api.auth.getInfo();

    if (isFailure(result)) {
      authMethod = result.error && result.error.authMethod;

      if (result.error.code === AuthServiceErrorCode.WRONG_USER_MODE) {
        dispatch(wrongUserMode());
      }

      dispatch(loadInfoFailure(result.error));
    } else {
      authMethod = result.data.authMethod;
      dispatch(loadInfoSuccess(result.data));
    }

    authMethod && dispatch(setAuthMethod(authMethod));
  };

export const wrongUserMode = (): InfoActionTypes => ({
  type: WRONG_USER_MODE,
});

export const loadInfoSuccess = (info: InfoData): InfoActionTypes => ({
  type: LOAD_INFO_SUCCESS,
  payload: info,
});
export const loadInfoFailure = (
  error: { code: number | string } | (AuthInfo & { code: number | string })
): InfoActionTypes => ({
  type: LOAD_INFO_FAILURE,
  payload: error,
});

export const setAuthMethod = (method: AuthMethod): InfoActionTypes => ({
  type: SET_AUTH_METHOD,
  payload: method,
});
